<app-side-menu>
  <div class="contract-form-container">
    <div class="header">
      <div class="d-flex align-items-center mb-3">
        <app-button 
          text="Voltar"
          color="var(--secondary-color)"
          (buttonClick)="onCancel()"
          className="me-3">
          <i class="fas fa-arrow-left me-2"></i>
        </app-button>
        <h2>
          <i class="fas fa-{{ isEditMode ? 'edit' : 'plus' }}"></i>
          {{ isEditMode ? 'Editar Contrato' : 'Novo Contrato' }}
        </h2>
      </div>
      <p>{{ isEditMode ? 'Atualize os detalhes do contrato existente.' : 'Gere um novo contrato automatizado com dados do cliente e produto.' }}</p>
    </div>

    <app-loading [show]="isLoading" message="Carregando dados..."></app-loading>

    <div *ngIf="!isLoading" class="form-card">
      <form [formGroup]="contractForm" (ngSubmit)="onSubmit()">

        <!-- Steps -->
        <div class="steps-indicator">
          <div class="step" [class.active]="currentStep === 1">
            <div class="step-number">1</div>
            <div class="step-info">
              <div class="step-title">Dados do contrato</div>
              <div class="step-subtitle">Produto, período, motorista e veículo</div>
            </div>
          </div>
          <div class="step" [class.active]="currentStep === 2">
            <div class="step-number">2</div>
            <div class="step-info">
              <div class="step-title">Pagamentos</div>
              <div class="step-subtitle">Caução e 1ª parcela</div>
            </div>
          </div>
        </div>

        <!-- STEP 1: Dados do contrato -->
        <div class="form-grid" *ngIf="currentStep === 1">

          <!-- Seção: Dados Básicos -->
          <div class="form-section">
            <h3><i class="fas fa-info-circle"></i> Dados Básicos</h3>

            <div class="form-row">
              <div class="form-group">
                <label for="productId" class="form-label">Produto/Plano *</label>
                <select id="productId" formControlName="productId" class="form-select"
                        [class.is-invalid]="contractForm.get('productId')?.invalid && contractForm.get('productId')?.touched">
                  <option value="">Selecione um produto</option>
                  <option *ngFor="let product of products" [value]="product.id">
                    {{ product.name }} ({{ product.code }}) - {{ formatPrice(product.basePrice) }}
                  </option>
                </select>
                <div class="invalid-feedback" *ngIf="contractForm.get('productId')?.invalid && contractForm.get('productId')?.touched">
                  Produto é obrigatório.
                </div>
              </div>
            </div>

            <!-- Campos calculados automaticamente -->
            <div class="form-row" *ngIf="contractForm.get('productId')?.value">
              <div class="form-group">
                <label class="form-label">Número de Parcelas</label>
                <input type="number" class="form-control" [value]="contractWeeksCount" readonly>
                <small class="form-text text-muted">Calculado automaticamente baseado no plano</small>
              </div>
              <div class="form-group">
                <label class="form-label">Valor Total do Contrato</label>
                <input type="text" class="form-control" [value]="formatPrice(contractWeeklyAmount * contractWeeksCount)" readonly>
                <small class="form-text text-muted">Valor semanal × número de parcelas</small>
              </div>
            </div>

            <!-- Template oculto - sempre template 2 -->
            <div class="form-group" style="display: none;">
              <input type="hidden" [(ngModel)]="selectedTemplate" [ngModelOptions]="{standalone: true}">
              <input type="hidden" [(ngModel)]="selectedTemplateVersion" [ngModelOptions]="{standalone: true}">
            </div>
          </div>

          <!-- Seção: Período do Contrato -->
          <div class="form-section">
            <h3><i class="fas fa-calendar-alt"></i> Período do Contrato</h3>

            <div class="form-row">
              <div class="form-group">
                <label for="startDate" class="form-label">Data de Início *</label>
                <input type="date" id="startDate" formControlName="startDate" class="form-control"
                       [class.is-invalid]="contractForm.get('startDate')?.invalid && contractForm.get('startDate')?.touched">
                <div class="invalid-feedback" *ngIf="contractForm.get('startDate')?.invalid && contractForm.get('startDate')?.touched">
                  Data de início é obrigatória.
                </div>
              </div>

              <div class="form-group">
                <label for="endDate" class="form-label">Data de Término *</label>
                <input type="date" id="endDate" formControlName="endDate" class="form-control"
                       [class.is-invalid]="contractForm.get('endDate')?.invalid && contractForm.get('endDate')?.touched">
                <div class="invalid-feedback" *ngIf="contractForm.get('endDate')?.invalid && contractForm.get('endDate')?.touched">
                  Data de término é obrigatória.
                </div>
              </div>
            </div>

            <div class="form-row">
              <div class="form-group">
                <label for="billingCycle" class="form-label">Ciclo de Cobrança *</label>
                <select id="billingCycle" formControlName="billingCycle" class="form-select"
                        [class.is-invalid]="contractForm.get('billingCycle')?.invalid && contractForm.get('billingCycle')?.touched">
                  <option value="Diário">Diário</option>
                  <option value="Semanal">Semanal</option>
                  <option value="Mensal">Mensal</option>
                  <option value="Trimestral">Trimestral</option>
                  <option value="Anual">Anual</option>
                </select>
                <div class="invalid-feedback" *ngIf="contractForm.get('billingCycle')?.invalid && contractForm.get('billingCycle')?.touched">
                  Ciclo de cobrança é obrigatório.
                </div>
              </div>

              <div class="form-group" style="display: none;">
                <label for="status" class="form-label">Status</label>
                <select id="status" formControlName="status" class="form-select"
                        [class.is-invalid]="contractForm.get('status')?.invalid && contractForm.get('status')?.touched">
                  <option value="Draft">Rascunho</option>
                  <option value="Pending">Pendente</option>
                  <option value="Signed">Assinado</option>
                  <option value="Active">Ativo</option>
                  <option value="Expired">Expirado</option>
                  <option value="Cancelled">Cancelado</option>
                </select>
                <div class="invalid-feedback" *ngIf="contractForm.get('status')?.invalid && contractForm.get('status')?.touched">
                  Status é obrigatório.
                </div>
              </div>
            </div>
          </div>

          <!-- Seção: Dados do Motorista -->
          <div class="form-section">
            <h3><i class="fas fa-user"></i> Dados do Motorista</h3>

            <div class="form-row">
              <div class="form-group autocomplete-container">
                <label for="driverName" class="form-label mb-0">Nome Completo *</label>
                <div class="input-group">
                  <input type="text" id="driverName" formControlName="driverName" class="form-control"
                         placeholder="Nome completo do motorista"
                         [class.is-invalid]="contractForm.get('driverName')?.invalid && contractForm.get('driverName')?.touched">
                  <button type="button" class="btn btn-outline-primary" (click)="searchCustomers()"
                          title="Buscar cliente cadastrado e preencher">
                    <i class="fas fa-search"></i>
                  </button>
                </div>
                <!-- Sugestões de clientes, alinhadas sob o campo -->
                <ul *ngIf="customerSearchResults.length > 0"
                    class="autocomplete-list">
                  <li *ngFor="let c of customerSearchResults"
                      class="autocomplete-item"
                      (click)="onSelectCustomer(c)">
                    <strong>{{ c.name }}</strong> — {{ c.documentNumber }} · {{ c.email || c.primaryPhone || 'Sem contato' }}
                  </li>
                </ul>
                <div class="invalid-feedback" *ngIf="contractForm.get('driverName')?.invalid && contractForm.get('driverName')?.touched">
                  Nome do motorista é obrigatório.
                </div>
              </div>

              <div class="form-group">
                <label for="driverCpfCnpj" class="form-label">CPF/CNPJ *</label>
                <input type="text" id="driverCpfCnpj" formControlName="driverCpfCnpj" class="form-control"
                       placeholder="000.000.000-00"
                       [class.is-invalid]="contractForm.get('driverCpfCnpj')?.invalid && contractForm.get('driverCpfCnpj')?.touched">
                <div class="invalid-feedback" *ngIf="contractForm.get('driverCpfCnpj')?.invalid && contractForm.get('driverCpfCnpj')?.touched">
                  CPF/CNPJ é obrigatório.
                </div>
              </div>
            </div>

            <div class="form-row">
              <div class="form-group">
                <label for="driverCnhNumber" class="form-label">Número da CNH *</label>
                <input type="text" id="driverCnhNumber" formControlName="driverCnhNumber" class="form-control"
                       placeholder="12345678901"
                       [class.is-invalid]="contractForm.get('driverCnhNumber')?.invalid && contractForm.get('driverCnhNumber')?.touched">
                <div class="invalid-feedback" *ngIf="contractForm.get('driverCnhNumber')?.invalid && contractForm.get('driverCnhNumber')?.touched">
                  Número da CNH é obrigatório.
                </div>
              </div>

              <div class="form-group">
                <label for="driverCnhExpiryDate" class="form-label">Validade da CNH *</label>
                <input type="date" id="driverCnhExpiryDate" formControlName="driverCnhExpiryDate" class="form-control"
                       [class.is-invalid]="contractForm.get('driverCnhExpiryDate')?.invalid && contractForm.get('driverCnhExpiryDate')?.touched">
                <div class="invalid-feedback" *ngIf="contractForm.get('driverCnhExpiryDate')?.invalid && contractForm.get('driverCnhExpiryDate')?.touched">
                  Validade da CNH é obrigatória.
                </div>
              </div>
            </div>

            <div class="form-row">
              <div class="form-group">
                <label for="driverEmail" class="form-label">E-mail *</label>
                <input type="email" id="driverEmail" formControlName="driverEmail" class="form-control"
                       placeholder="email@exemplo.com"
                       [class.is-invalid]="contractForm.get('driverEmail')?.invalid && contractForm.get('driverEmail')?.touched">
                <div class="invalid-feedback" *ngIf="contractForm.get('driverEmail')?.invalid && contractForm.get('driverEmail')?.touched">
                  E-mail é obrigatório.
                </div>
              </div>

              <div class="form-group">
                <label for="driverPhone" class="form-label">Telefone *</label>
                <input type="text" id="driverPhone" formControlName="driverPhone" class="form-control"
                       placeholder="(11) 99999-9999"
                       [class.is-invalid]="contractForm.get('driverPhone')?.invalid && contractForm.get('driverPhone')?.touched">
                <div class="invalid-feedback" *ngIf="contractForm.get('driverPhone')?.invalid && contractForm.get('driverPhone')?.touched">
                  Telefone é obrigatório.
                </div>
              </div>
            </div>

            <div class="form-row">
              <div class="form-group">
                <label for="driverStreet" class="form-label">Rua *</label>
                <input type="text" id="driverStreet" formControlName="driverStreet" class="form-control"
                       placeholder="Nome da rua"
                       [class.is-invalid]="contractForm.get('driverStreet')?.invalid && contractForm.get('driverStreet')?.touched">
                <div class="invalid-feedback" *ngIf="contractForm.get('driverStreet')?.invalid && contractForm.get('driverStreet')?.touched">
                  Rua é obrigatória.
                </div>
              </div>

              <div class="form-group">
                <label for="driverNumber" class="form-label">Número *</label>
                <input type="text" id="driverNumber" formControlName="driverNumber" class="form-control"
                       placeholder="123"
                       [class.is-invalid]="contractForm.get('driverNumber')?.invalid && contractForm.get('driverNumber')?.touched">
                <div class="invalid-feedback" *ngIf="contractForm.get('driverNumber')?.invalid && contractForm.get('driverNumber')?.touched">
                  Número é obrigatório.
                </div>
              </div>
            </div>

            <div class="form-row">
              <div class="form-group">
                <label for="driverComplement" class="form-label">Complemento</label>
                <input type="text" id="driverComplement" formControlName="driverComplement" class="form-control"
                       placeholder="Apto 45, Bloco A">
              </div>

              <div class="form-group">
                <label for="driverDistrict" class="form-label">Bairro *</label>
                <input type="text" id="driverDistrict" formControlName="driverDistrict" class="form-control"
                       placeholder="Nome do bairro"
                       [class.is-invalid]="contractForm.get('driverDistrict')?.invalid && contractForm.get('driverDistrict')?.touched">
                <div class="invalid-feedback" *ngIf="contractForm.get('driverDistrict')?.invalid && contractForm.get('driverDistrict')?.touched">
                  Bairro é obrigatório.
                </div>
              </div>
            </div>

            <div class="form-row">
              <div class="form-group">
                <label for="driverCity" class="form-label">Cidade *</label>
                <input type="text" id="driverCity" formControlName="driverCity" class="form-control"
                       placeholder="Nome da cidade"
                       [class.is-invalid]="contractForm.get('driverCity')?.invalid && contractForm.get('driverCity')?.touched">
                <div class="invalid-feedback" *ngIf="contractForm.get('driverCity')?.invalid && contractForm.get('driverCity')?.touched">
                  Cidade é obrigatória.
                </div>
              </div>

              <div class="form-group">
                <label for="driverState" class="form-label">Estado *</label>
                <input type="text" id="driverState" formControlName="driverState" class="form-control"
                       placeholder="SP" maxlength="2"
                       [class.is-invalid]="contractForm.get('driverState')?.invalid && contractForm.get('driverState')?.touched">
                <div class="invalid-feedback" *ngIf="contractForm.get('driverState')?.invalid && contractForm.get('driverState')?.touched">
                  Estado é obrigatório.
                </div>
              </div>
            </div>

            <div class="form-row">
              <div class="form-group">
                <label for="driverZipCode" class="form-label">CEP *</label>
                <input type="text" id="driverZipCode" formControlName="driverZipCode" class="form-control"
                       placeholder="01234-567"
                       [class.is-invalid]="contractForm.get('driverZipCode')?.invalid && contractForm.get('driverZipCode')?.touched">
                <div class="invalid-feedback" *ngIf="contractForm.get('driverZipCode')?.invalid && contractForm.get('driverZipCode')?.touched">
                  CEP é obrigatório.
                </div>
              </div>
            </div>
          </div>

          <!-- Seção: Dados e Inspeção do Veículo -->
          <div class="form-section">
            <h3><i class="fas fa-car"></i> Dados do Veículo e Inspeção</h3>

            <!-- Dados do veículo (preenchidos manualmente) -->
            <div class="form-row">
              <div class="form-group autocomplete-container">
                <label for="vs_plate" class="form-label">Placa *</label>
                <div class="input-group">
                  <input type="text" id="vs_plate" class="form-control" formControlName="vs_plate" placeholder="ABC-1234">
                  <button type="button" class="btn btn-outline-primary" (click)="searchVehicles()"
                          title="Buscar veículo cadastrado e preencher">
                    <i class="fas fa-search"></i>
                  </button>
                </div>
                <!-- Sugestões de veículos, alinhadas sob o campo -->
                <ul *ngIf="vehicleSearchResults.length > 0"
                    class="autocomplete-list">
                  <li *ngFor="let v of vehicleSearchResults"
                      class="autocomplete-item"
                      (click)="onSelectVehicle(v)">
                    <strong>{{ v.plateNumber }}</strong> — {{ v.brand }} {{ v.model }} {{ v.modelYear || '' }}
                  </li>
                </ul>
              </div>
              <div class="form-group">
                <label for="vs_model" class="form-label">Modelo *</label>
                <input type="text" id="vs_model" class="form-control" formControlName="vs_model" placeholder="Honda CB 600">
              </div>
            </div>

            <div class="form-row">
              <div class="form-group">
                <label for="vs_year" class="form-label">Ano *</label>
                <input type="number" id="vs_year" class="form-control" formControlName="vs_year" placeholder="2020">
              </div>
              <div class="form-group">
                <label for="vs_color" class="form-label">Cor *</label>
                <input type="text" id="vs_color" class="form-control" formControlName="vs_color" placeholder="Vermelho">
              </div>
              <div class="form-group">
                <label for="vs_brand" class="form-label">Marca *</label>
                <input type="text" id="vs_brand" class="form-control" formControlName="vs_brand" placeholder="Honda">
              </div>
            </div>

            <div class="form-row">
              <div class="form-group">
                <label for="vs_renavam" class="form-label">RENAVAM *</label>
                <input type="text" id="vs_renavam" class="form-control" formControlName="vs_renavam" placeholder="12345678901">
              </div>
              <div class="form-group">
                <label for="vs_chassis" class="form-label">Chassi *</label>
                <input type="text" id="vs_chassis" class="form-control" formControlName="vs_chassis" placeholder="9BW1234567890123">
              </div>
              <div class="form-group">
                <label for="vs_currentKm" class="form-label">KM Atual *</label>
                <input type="text" id="vs_currentKm" class="form-control" formControlName="vs_currentKm" appNumberMask [decimals]="0" placeholder="Ex: 15.000">
              </div>
            </div>

            <div class="form-row" *ngIf="vehicleSearchResults.length > 0">
              <div class="form-group" style="width: 100%;">
                <label class="form-label">Veículos encontrados (clique para selecionar)</label>
                <ul class="list-group list-group-flush" style="max-height: 200px; overflow-y: auto;">
                  <li class="list-group-item list-group-item-action" *ngFor="let v of vehicleSearchResults"
                      (click)="onSelectVehicle(v)" style="cursor: pointer;">
                    <strong>{{ v.plateNumber }}</strong> — {{ v.brand }} {{ v.model }} {{ v.modelYear || '' }}
                  </li>
                </ul>
              </div>
            </div>

            <!-- Observações de inspeção -->
            <div class="form-group">
              <label for="vehicleInspectionNotes" class="form-label">Observações da Inspeção *</label>
              <textarea id="vehicleInspectionNotes" formControlName="vehicleInspectionNotes" class="form-control"
                        rows="4" placeholder="Descreva o estado atual do veículo, avarias, quilometragem, etc..."
                        [class.is-invalid]="contractForm.get('vehicleInspectionNotes')?.invalid && contractForm.get('vehicleInspectionNotes')?.touched"></textarea>
              <div class="invalid-feedback" *ngIf="contractForm.get('vehicleInspectionNotes')?.invalid && contractForm.get('vehicleInspectionNotes')?.touched">
                Observações da inspeção são obrigatórias.
              </div>
            </div>
          </div>
        </div>

        <!-- STEP 2: Pagamentos -->
        <div class="form-grid" *ngIf="currentStep === 2">
          <div class="form-section">
            <h3><i class="fas fa-dollar-sign"></i> Pagamentos (Caução e 1ª Parcela)</h3>

            <!-- Valores totais -->
            <div class="form-row">
              <div class="form-group">
                <label class="form-label">Valor 1ª Parcela</label>
                <input type="text" class="form-control"
                       [value]="formatPrice(contractForm.get('baseAmount')?.value || 0)" readonly>
              </div>
              <div class="form-group">
                <label class="form-label">Valor Caução</label>
                <input type="text" class="form-control"
                       [value]="formatPrice(contractForm.get('depositAmount')?.value || 0)" readonly>
              </div>
            </div>

            <!-- Caução -->
            <div class="form-row">
              <div class="form-group" style="width: 100%;">
                <label class="form-label">Quantidade de métodos de pagamento da caução</label>
                <select class="form-select"
                        [(ngModel)]="depositPaymentMode"
                        (ngModelChange)="setDepositPaymentMode($event)"
                        [ngModelOptions]="{ standalone: true }">
                  <option [ngValue]="'single'">1 método</option>
                  <option [ngValue]="'split'">2 métodos</option>
                </select>
              </div>
            </div>

            <div class="form-row" *ngFor="let p of depositPayments; let i = index"
                 [hidden]="depositPaymentMode === 'single' && i === 1">
              <div class="form-group">
                <label class="form-label">Método {{ i + 1 }}</label>
                <select class="form-select"
                        [ngModel]="depositPayments[i].method"
                        (ngModelChange)="onDepositMethodChange(i, $event)"
                        [ngModelOptions]="{ standalone: true }">
                  <option *ngFor="let m of paymentMethods" [value]="m.value">{{ m.label }}</option>
                </select>
              </div>
              <div class="form-group">
                <label class="form-label">Valor</label>
                <input type="number" class="form-control currency-input"
                       [ngModel]="depositPayments[i].amount ? depositPayments[i].amount : null"
                       (ngModelChange)="onDepositAmountChange(i, $event)"
                       [ngModelOptions]="{ standalone: true }"
                       min="0" step="0.01"
                       [readonly]="depositPaymentMode === 'single'"
                       [max]="contractForm.get('depositAmount')?.value || 0">
              </div>
            </div>

            <!-- Parcelamento do boleto da caução (1x até 10x) -->
            <div class="form-row" *ngIf="hasDepositBoleto()">
              <div class="form-group">
                <label class="form-label">Parcelas do boleto da caução</label>
                <select class="form-select"
                        [(ngModel)]="depositInstallments"
                        [ngModelOptions]="{ standalone: true }">
                  <option [value]="1">À vista (1x)</option>
                  <option *ngFor="let n of [2,3,4,5,6,7,8,9,10]" [value]="n">
                    {{ n }}x
                  </option>
                </select>
                <small class="text-muted">
                  O valor em boleto será dividido em {{ depositInstallments }} parcela(s).
                </small>
              </div>
            </div>

            <!-- Pagamento da caução no cartão (Asaas) -->
            <div class="form-row" *ngIf="hasDepositCard()">
              <div class="form-group" style="width: 100%;">
                <label class="form-label">Pagamento da caução no cartão (Asaas)</label>
                <div class="alert alert-info" *ngIf="!asaasCustomerId">
                  <i class="fa-solid fa-circle-info"></i>
                  Para pagar a caução no cartão é necessário que o cliente esteja cadastrado no Asaas (CPF/CNPJ válido).
                </div>
              </div>
            </div>

            <!-- Cartão 1 - vinculado ao Método 1 da caução -->
            <div class="card-payment-wrapper" *ngIf="depositPayments[0]?.method === 'CREDIT_CARD'">
              <!-- Visual do cartão (frente e verso com flip) -->
              <div class="card-visual">
                <div class="card-visual-inner" [class.is-back]="isCardBack">
                  <!-- Frente -->
                  <div class="card-face card-front">
                    <div class="card-visual-header">
                      <span class="card-brand">
                        <i class="fa-solid fa-credit-card me-1"></i>
                        {{ cardBrand }}
                      </span>
                    </div>
                    <div class="card-visual-number">
                      {{ maskedCardNumber }}
                    </div>
                    <div class="card-visual-footer">
                      <div class="card-holder">
                        <span class="label">NOME</span>
                        <span class="value">{{ creditCardHolderName || 'NOME DO TITULAR' }}</span>
                      </div>
                      <div class="card-expiry">
                        <span class="label">VALIDADE</span>
                        <span class="value">
                          {{ (creditCardExpiryMonth || 'MM') }}/{{ (creditCardExpiryYear || 'AAAA') }}
                        </span>
                      </div>
                    </div>
                  </div>
                  <!-- Verso -->
                  <div class="card-face card-back-face">
                    <div class="card-magnetic-strip"></div>
                    <div class="card-cvv-area">
                      <span class="label">CVV</span>
                      <span class="cvv-box">{{ creditCardCcv || '•••' }}</span>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Formulário do cartão -->
              <div class="card-form">
                <div class="form-row">
                  <div class="form-group">
                    <label class="form-label">Número do cartão</label>
                    <input type="text"
                           class="form-control"
                           [(ngModel)]="creditCardNumber"
                           [ngModelOptions]="{ standalone: true }"
                           placeholder="0000 0000 0000 0000"
                           maxlength="19"
                           (input)="onCreditCardNumberInput($event)">
                  </div>
                </div>

                <div class="form-row">
                  <div class="form-group">
                    <label class="form-label">Nome impresso no cartão</label>
                    <input type="text"
                           class="form-control"
                           [(ngModel)]="creditCardHolderName"
                           [ngModelOptions]="{ standalone: true }"
                           placeholder="Nome completo">
                  </div>
                </div>

                <div class="form-row">
                  <div class="form-group">
                    <label class="form-label">Validade (MM/AAAA)</label>
                    <div class="card-expiry-group">
                      <input type="text"
                             class="form-control"
                             [(ngModel)]="creditCardExpiryMonth"
                             [ngModelOptions]="{ standalone: true }"
                             placeholder="MM"
                             maxlength="2">
                      <span class="separator">/</span>
                      <input type="text"
                             class="form-control"
                             [(ngModel)]="creditCardExpiryYear"
                             [ngModelOptions]="{ standalone: true }"
                             placeholder="AAAA"
                             maxlength="4">
                    </div>
                  </div>
                  <div class="form-group">
                    <label class="form-label">CVV</label>
                    <input type="text"
                           class="form-control"
                           [(ngModel)]="creditCardCcv"
                           [ngModelOptions]="{ standalone: true }"
                           maxlength="4"
                           placeholder="CVV"
                           (focus)="setCardBack(true, 1)"
                           (blur)="setCardBack(false, 1)">
                  </div>
                </div>

              </div>
            </div>

            <!-- Cartão 2 - vinculado ao Método 2 da caução -->
            <div class="card-payment-wrapper" *ngIf="depositPayments[1]?.method === 'CREDIT_CARD'">
              <!-- Visual do cartão 2 -->
              <div class="card-visual">
                <div class="card-visual-inner" [class.is-back]="isCardBack2">
                  <!-- Frente -->
                  <div class="card-face card-front">
                    <div class="card-visual-header">
                      <span class="card-brand">
                        <i class="fa-solid fa-credit-card me-1"></i>
                        {{ cardBrand2 }}
                      </span>
                    </div>
                    <div class="card-visual-number">
                      {{ maskedCardNumber2 }}
                    </div>
                    <div class="card-visual-footer">
                      <div class="card-holder">
                        <span class="label">NOME</span>
                        <span class="value">{{ creditCardHolderName2 || 'NOME DO TITULAR' }}</span>
                      </div>
                      <div class="card-expiry">
                        <span class="label">VALIDADE</span>
                        <span class="value">
                          {{ (creditCardExpiryMonth2 || 'MM') }}/{{ (creditCardExpiryYear2 || 'AAAA') }}
                        </span>
                      </div>
                    </div>
                  </div>
                  <!-- Verso -->
                  <div class="card-face card-back-face">
                    <div class="card-magnetic-strip"></div>
                    <div class="card-cvv-area">
                      <span class="label">CVV</span>
                      <span class="cvv-box">{{ creditCardCcv2 || '•••' }}</span>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Formulário do cartão 2 -->
              <div class="card-form">
                <div class="form-row">
                  <div class="form-group">
                    <label class="form-label">Número do cartão (2)</label>
                    <input type="text"
                           class="form-control"
                           [(ngModel)]="creditCardNumber2"
                           [ngModelOptions]="{ standalone: true }"
                           placeholder="0000 0000 0000 0000"
                           maxlength="19"
                           (input)="onCreditCardNumber2Input($event)">
                  </div>
                </div>

                <div class="form-row">
                  <div class="form-group">
                    <label class="form-label">Nome impresso no cartão (2)</label>
                    <input type="text"
                           class="form-control"
                           [(ngModel)]="creditCardHolderName2"
                           [ngModelOptions]="{ standalone: true }"
                           placeholder="Nome completo">
                  </div>
                </div>

                <div class="form-row">
                  <div class="form-group">
                    <label class="form-label">Validade (MM/AAAA) (2)</label>
                    <div class="card-expiry-group">
                      <input type="text"
                             class="form-control"
                             [(ngModel)]="creditCardExpiryMonth2"
                             [ngModelOptions]="{ standalone: true }"
                             placeholder="MM"
                             maxlength="2">
                      <span class="separator">/</span>
                      <input type="text"
                             class="form-control"
                             [(ngModel)]="creditCardExpiryYear2"
                             [ngModelOptions]="{ standalone: true }"
                             placeholder="AAAA"
                             maxlength="4">
                    </div>
                  </div>
                  <div class="form-group">
                    <label class="form-label">CVV (2)</label>
                    <input type="text"
                           class="form-control"
                           [(ngModel)]="creditCardCcv2"
                           [ngModelOptions]="{ standalone: true }"
                           maxlength="4"
                           placeholder="CVV"
                           (focus)="setCardBack(true, 2)"
                           (blur)="setCardBack(false, 2)">
                  </div>
                </div>

                <!-- usa o mesmo número de parcelas da caução para os dois cartões -->
              </div>
            </div>

            <!-- Parcelamento da caução no cartão 1 -->
            <div class="form-row" *ngIf="depositPayments[0]?.method === 'CREDIT_CARD'">
              <div class="form-group">
                <label class="form-label">Parcelas do cartão (Método 1)</label>
                <select class="form-select"
                        [(ngModel)]="depositCardInstallments"
                        [ngModelOptions]="{ standalone: true }">
                  <option [value]="1">À vista (1x)</option>
                  <option *ngFor="let n of [2,3,4,5,6,7,8,9,10]" [value]="n">
                    {{ n }}x
                  </option>
                </select>
                <small class="text-muted">
                  O valor da caução no cartão do Método 1 será dividido em {{ depositCardInstallments }} parcela(s).
                </small>
              </div>
            </div>

            <!-- Parcelamento da caução no cartão 2 -->
            <div class="form-row" *ngIf="depositPayments[1]?.method === 'CREDIT_CARD'">
              <div class="form-group">
                <label class="form-label">Parcelas do cartão (Método 2)</label>
                <select class="form-select"
                        [(ngModel)]="depositCardInstallments2"
                        [ngModelOptions]="{ standalone: true }">
                  <option [value]="1">À vista (1x)</option>
                  <option *ngFor="let n of [2,3,4,5,6,7,8,9,10]" [value]="n">
                    {{ n }}x
                  </option>
                </select>
                <small class="text-muted">
                  O valor da caução no cartão do Método 2 será dividido em {{ depositCardInstallments2 }} parcela(s).
                </small>
              </div>
            </div>

            <hr>

            <!-- 1ª Parcela -->
            <div class="form-row">
              <div class="form-group" style="width: 100%;">
                <label class="form-label">Quantidade de métodos de pagamento da 1ª parcela</label>
                <select class="form-select"
                        [(ngModel)]="firstInstallmentPaymentMode"
                        (ngModelChange)="setFirstInstallmentPaymentMode($event)"
                        [ngModelOptions]="{ standalone: true }">
                  <option [ngValue]="'single'">1 método</option>
                  <option [ngValue]="'split'">2 métodos</option>
                </select>
              </div>
            </div>

            <div class="form-row" *ngFor="let p of firstInstallmentPayments; let i = index"
                 [hidden]="firstInstallmentPaymentMode === 'single' && i === 1">
              <div class="form-group">
                <label class="form-label">Método {{ i + 1 }}</label>
                <select class="form-select"
                        [(ngModel)]="firstInstallmentPayments[i].method"
                        [ngModelOptions]="{ standalone: true }">
                  <option *ngFor="let m of paymentMethods" [value]="m.value">{{ m.label }}</option>
                </select>
              </div>
              <div class="form-group">
                <label class="form-label">Valor</label>
                <input type="number" class="form-control currency-input"
                       [ngModel]="firstInstallmentPayments[i].amount ? firstInstallmentPayments[i].amount : null"
                       (ngModelChange)="onFirstInstallmentAmountChange(i, $event)"
                       [ngModelOptions]="{ standalone: true }"
                       min="0" step="0.01"
                       [readonly]="firstInstallmentPaymentMode === 'single'"
                       [max]="contractForm.get('baseAmount')?.value || 0">
              </div>
            </div>
          </div>
        </div>

        <!-- Form Actions -->
        <div class="form-actions">
          <button type="button" class="btn-secondary" (click)="onCancel()" [disabled]="isLoading">
            <i class="fa-solid fa-times"></i>
            Cancelar
          </button>

          <!-- Navegação entre steps -->
          <button *ngIf="currentStep === 1"
                  type="button"
                  class="btn-primary"
                  (click)="goToStep(2)">
            Próximo
          </button>

          <ng-container *ngIf="currentStep === 2">
            <button type="button"
                    class="btn-secondary"
                    (click)="goToStep(1)">
              Voltar
            </button>
            <button type="submit"
                    class="btn-primary"
                    [disabled]="isSubmitDisabled">
              <span *ngIf="isGenerating || isSaving" class="spinner-border spinner-border-sm me-2" role="status"></span>
              <i *ngIf="!isGenerating && !isSaving" class="fa-solid fa-save me-2"></i>
              {{ submitButtonText }}
            </button>
          </ng-container>
        </div>
      </form>
    </div>
  </div>
</app-side-menu>
